module.exports = __webpack_public_path__ + "img/21.157944ea.jpg";